import { Badge } from "react-bootstrap";

const DAY_MS = 86400000;
const EXPIRING_SOON_WINDOW_DAYS = 7;

/** Derives a subscription's display status purely from `active`/`expireDate` — no backend field for this. */
export function getSubscriptionStatus(sub) {
  const active = sub.active === true || sub.active === 1;
  if (!active) return "Suspended";

  const expireMs = Number(sub.expireDate);
  if (!Number.isFinite(expireMs)) return "Active";

  const now = Date.now();
  if (expireMs <= now) return "Expired";
  if ((expireMs - now) / DAY_MS <= EXPIRING_SOON_WINDOW_DAYS) return "Expiring Soon";
  return "Active";
}

const STATUS_STYLES = {
  Active:         { background: "rgba(16,185,129,0.14)", color: "#34d399", border: "1px solid rgba(16,185,129,0.35)" },
  "Expiring Soon": { background: "rgba(245,158,11,0.14)", color: "#fbbf24", border: "1px solid rgba(245,158,11,0.35)" },
  Expired:        { background: "rgba(239,68,68,0.14)",  color: "#f87171", border: "1px solid rgba(239,68,68,0.35)" },
  Suspended:      { background: "rgba(148,163,184,0.14)", color: "#94a3b8", border: "1px solid rgba(148,163,184,0.35)" },
};

export default function StatusChip({ subscription, status }) {
  const s = status || getSubscriptionStatus(subscription);
  return (
    <Badge bg="" style={{ ...STATUS_STYLES[s], fontSize: "0.72rem", fontWeight: 600 }}>
      {s}
    </Badge>
  );
}
